module.exports = __webpack_public_path__ + "img/1659496672291-aset 1.png.639f017d.webp";